import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function UserRegisterAlias() {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;
    const { ref } = router.query;
    const query = typeof ref === 'string' && ref.trim() ? `?ref=${encodeURIComponent(ref)}` : '';
    router.replace(`/user/signup${query}`);
  }, [router]);

  return null;
}


export { getServerSideProps } from '@/lib/panelSsr';
